import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { ResponsiveHeader } from "pages/_components/header";
import { bool } from "prop-types";
import React from "react";
import { billTabs } from "util/creditBills";
import { CreditBillTabs } from "./CreditBillsTabs";

const CreditBillsPage = ({ isDesktop }) => {
    const tabsData = [
        {
            text: "creditBill.tab.emitted",
            textType: "I18N",
        },
        {
            text: "creditBill.tab.inTenure",
            textType: "I18N",
        },
        {
            text: "creditBill.tab.received",
            textType: "I18N",
        },
        {
            text: "creditBill.tab.toPay",
            textType: "I18N",
        },
    ];
    return (
        <>
            <Notification scopeToShow="creditBillsPage" />
            <ResponsiveHeader id="creditBill.main.header.title" backLinkTo="/desktop" />
            <MainContainer className="credit-bills">
                <CustomTabs tabsData={tabsData}>
                    <CreditBillTabs isDesktop={isDesktop} tabOption={billTabs.EMITTED} positionTab={0} />
                    <CreditBillTabs isDesktop={isDesktop} tabOption={billTabs.IN_TENURE} positionTab={1} />
                    <CreditBillTabs isDesktop={isDesktop} tabOption={billTabs.RECEIVED} positionTab={2} />
                    <CreditBillTabs isDesktop={isDesktop} tabOption={billTabs.TO_PAY} positionTab={3} />
                </CustomTabs>
            </MainContainer>
        </>
    );
};

CreditBillsPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default CreditBillsPage;
